<script lang="ts">
export default {
  name: 'KkMarkdownView',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'
import { marked } from 'marked'

export interface Props {
  content?: string
}

const props = withDefaults(defineProps<Props>(), { content: '' })
const compiledMarkdown = computed(() => marked(props.content))
</script>

<template>
  <div>
    <div v-html="compiledMarkdown" />
  </div>
</template>
